import React from "react";
import { FormControl } from "react-bootstrap";
import SurveyField from "../../components/SurveyField";

const TextQuestionFields = ({ question, readOnly, update, inspector }) => (
  <div className={`survey-engine-form-grid ${inspector ? "survey-engine-inspector-grid" : ""}`}>
    <SurveyField label="Textbox style" required>
      <FormControl componentClass="select" value={question.inputStyle || "multi_line"} disabled={readOnly} onChange={(event) => update("inputStyle", event.target.value)}>
        <option value="single_line">Single line</option>
        <option value="multi_line">Multiple lines</option>
      </FormControl>
    </SurveyField>
    <SurveyField label="Customer textbox placeholder">
      <FormControl placeholder="e.g. Type your answer" value={question.placeholder || ""} disabled={readOnly} onChange={(event) => update("placeholder", event.target.value)} />
    </SurveyField>
  </div>
);

export default TextQuestionFields;
